import React from 'react'
import { Dropdown, Form } from 'semantic-ui-react'

export default function NumberSelect(props) {
  if (!props.max || props.max < 0) return null

  const options = Array(props.max - props.min + 1)
    .fill({})
    .map((_, i) => ({
      key: i + 1,
      value: props.factor(i + 1),
      text: `${props.factor(i + 1)}`,
    }))

  return (
    <Form.Field>
      <label>{props.label}</label>
      <Dropdown
        selection
        search={false}
        selectOnBlur={false}
        selectOnNavigation={false}
        placeholder={props.placeholder || props.label}
        options={options}
        value={props.value}
        onChange={(_, { value }) => props.onChange(value)}
      />
    </Form.Field>
  )
}

NumberSelect.defaultProps = {
  min: 1,
  max: 5,
  factor: value => value,
  search: false,
  label: '',
  placeholder: '',
  onChange: () => {},
}
